package org.example.project.service

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.utils.All
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit
import kotlin.js.Date

object ProzessLoggerService {

    private val SERVER_URL: String
        get() = window.location.origin

    private val json = Json {
        prettyPrint = true
        ignoreUnknownKeys = true
    }

    private fun headers() = LumaticaApiManager.auditHeaders("application/json")

    private fun nowEpochMillis(): Long = Date().getTime().toLong()

    suspend fun loadRecent(limit: Int = 60): List<All> {
        val res = window.fetch("$SERVER_URL/data/prozesslog").await()
        val raw = res.text().await()
        if (!res.ok) error("Prozesslog konnte nicht geladen werden: ${res.status} $raw")
        if (raw.isBlank() || raw == "[]") return emptyList()
        val all = json.decodeFromString(ListSerializer(All.AllNames.serializer()), raw)
        return all.sortedByDescending { it.timestamp.toLongOrNull() ?: 0L }
            .take(limit.coerceAtLeast(1))
    }

    suspend fun append(
        eventType: String,
        message: String,
        after: All,
        before: All? = null
    ) {
        val actor = LoginService.getKuerzel()
            .ifBlank { after.fahrername.ifBlank { "SYSTEM" } }

        val prozesslogEintrag = All(
            typ = "PROCESS_$eventType",
            notiz = message,
            lfdNr = after.lfdNr,
            lieferscheinnummer = after.lieferscheinnummer,
            lkwkennzeichen = after.lkwkennzeichen,
            auftragsart = after.auftragsart,
            tor = after.tor,
            zustand = after.zustand,
            timestamp = nowEpochMillis().toString(),
            source = eventType,
            status = ZustandManager.textFor(after.zustand)
        )

        val body = json.encodeToString(All.AllNames.serializer(), prozesslogEintrag)
        val logId = "${nowEpochMillis()}_${eventType.lowercase()}_${actor.lowercase()}"
        val res = window.fetch(
            "$SERVER_URL/data/prozesslog/$logId.json",
            RequestInit(method = "POST", headers = headers(), body = body)
        ).await()
        if (!res.ok) error("Prozesslog konnte nicht geschrieben werden: ${res.status} ${res.text().await()}")
    }

}
